<template>
<div>
    <b-row>
        <b-col md="6" class="my-1">
            <h3 class="text-themecolor">Modules</h3>
        </b-col>
        <b-col md="6" class="my-1">
            <div class="pull-right">
                <b-button v-b-modal.modalModules variant="themecolor" size="sm" @click.stop="loadModal(null)">{{$t('buttons.toevoegen')}}</b-button>
            </div>
        </b-col>
    </b-row>

    <b-row>
        <b-col md="12">
            <div class="card">
                <div class="card-body">
                    <!-- Main table element -->
                    <b-row>
                        <b-col md="12">
                            <b-table show-empty
                                     :empty-text="getEmptyText(count)"
                                     class="table-hover" 
                                     :items="modules" 
                                     :fields="fields"
                                     :busy="count == -1">
                                <template v-slot:cell(createdAt)="data">{{data.item.createdAt | date }}</template>
                                <template v-slot:cell(actions)="row">
                                    <b-button v-b-modal.modalModules variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
                                        <i class="fa fa-edit" aria-hidden="true"></i>
                                    </b-button>
                                    <delete title="Module" :noRedirect="true" :hideText="true" :id="row.item.id" namespace="core" resource="modules" />
                                </template>
                                <template v-slot:table-busy>
                                    <PreLoader/>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- Main table element -->
                </div>
            </div>
        </b-col>
    </b-row>
    <!-- Modal Component -->
    <b-modal id="modalModules" ref="modules" :title="`Modules ${command.id ? $t('klantrelaties.bewerker') : $t('klantrelaties.aanmaker')}`" hide-footer centered cancel-title="Annuleren" ok-variant="themecolor" ok-title="Opslaan">
        <b-form @submit="onSubmit" autocomplete="off">
            <!-- Form content -->
            <b-form-group label-cols :label="$t('datatables.modulenaam')" label-for="name">
                <b-form-input id="name" v-model="command.name" type="text" :placeholder="$t('datatables.modulenaam')" />
                <validation element="name" />
            </b-form-group>
            <!-- Form content -->
            <hr />
            <!-- Submit controls -->
            <b-row>
                <b-col md="12">
                    <b-button @click="$refs.modules.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                    <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                </b-col>
            </b-row>
            <!-- Submit controls -->
        </b-form>
    </b-modal>
    <!-- Modal Component -->
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from 'vuex'

//Import command
import Command from './command'
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: 'modules-index',
    components: {PreLoader},
    data() {
        return {
            command: {},
            count: -1,
        }
    },
    computed: { 
        fields() {
            return [{
                    key: 'name',
                    label: this.$i18n.t('datatables.modulenaam'),
                },
                {
                    key: 'createdAt',
                    label: this.$i18n.t('datatables.aanmaakdatum'),
                },
                {
                    key: 'actions',
                    label: this.$i18n.t('datatables.acties')
                }
            ]
        },
        ...mapGetters('core', ['modules'])
    },
    methods: {
        ...mapActions('core', ['all', 'create', 'update', 'delete']),
        loadModal(item) {
            let vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.command = new Command(item);
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;

            let payload = {
                resource: 'modules',
                path: vm.$route.path,
                params: vm.command
            };

            let action = vm.command.id ? vm.update(payload) : vm.create(payload);
            action.then(() => {
                vm.$refs.modules.hide();
            })
        },
        getEmptyText,
    },
    created() {
        let vm = this;
        vm.all({
            resource: 'modules'
        })
        .then((data) => {
            vm.count = data.result.length;
        });
    }
}
</script>
